module.exports = __webpack_public_path__ + "static/5-773f622b69497eee9a0451c6734ca70b.jpeg";